$ = require 'jquery'
Controller = require 'controller'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
logError = require 'debug/log-error'

# TODO: scrap instances of this.
module.exports = class ChangeUserInfoPopoverView extends View
  viewTitleKey: 'change name and bio'

  events:
    'click .js-save-changes': 'saveChanges'

  render: ->
    view = @
    data = @model.toJSON(prefs: true)

    @$el.html(
      templates.fill('popover_change_user_info', data)
    )

    @

  getValue: (name) -> @$("[name=#{name}]").val()
  showError: (msg) ->
    key = switch msg.trim().toLowerCase()
      when 'username is taken'
        'username taken'
      when 'username must be at least 3 characters'
        'username too short'
      when 'username is invalid: only lowercase letters, underscores, and numbers are allowed'
        'username invalid'
      when 'full name must be at least 1 character'
        'full name too short'
      when 'full name must not contain a url'
        'full name must not contain a url'
      when 'initials must contain 1-4 characters'
        'initials wrong length'
      else
        logError new Error("Unknown server error message '#{msg}'")
        'unknown'

    @$('#account-error').text(l(['member profile error', key])).show()

  saveChanges: (e) ->
    view = @
    Util.preventDefault(e)
    data = {}

    @$('#account-error').hide()

    for name in ['fullName', 'initials', 'username', 'bio']
      data[name] = $.trim(@getValue(name))

    data.username = data.username.toLowerCase().replace(/[^a-z0-9_]/g, "")
    data.initials = data.initials.toUpperCase()
    # If we are on our account page and the username changed, the url will change
    viewingProfile = Controller.getMemberProfileUrl(@model.get('username')) == Controller.location

    @model.update data, waitForServer: true, (err) =>
      if err
        @showError(err.message)
      else
        PopOver.popView()
        if viewingProfile
          Controller.setLocation
            location: Controller.getMemberProfileUrl @model.get('username')
        track("Member", "Successfully Change User Info")
      return

    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/change-user-info-popover-view.coffee